const translations = {
    en: {
        WELCOME_BACK: 'Welcome back',
        SUBTITLE: 'Sign in to your RealColibri account.',
        ACCOUNT_LOGIN: 'ACCOUNT LOGIN',
        USERNAME_PLACEHOLDER: 'Username',
        PASSWORD_PLACEHOLDER: 'Password',
        LOGIN: 'Sign in',
        REQUIRED_FIELD: 'required field',
        OR: 'or with username',
        LOGIN_WITH_TRONLINK: 'Sign in with TronLink',
        TRONLINK_PROMPT: 'Recommended — connect the wallet you registered with.',
        TRONLINK_REFRESH_PROMPT:
            'Install TronLink and refresh the page to sign in with your wallet.',
    },
    es: {
        WELCOME_BACK: 'Bienvenido de nuevo',
        SUBTITLE: 'Inicia sesión en tu cuenta de RealColibri.',
        ACCOUNT_LOGIN: 'INICIAR SESIÓN',
        USERNAME_PLACEHOLDER: 'Nombre de usuario',
        PASSWORD_PLACEHOLDER: 'Contraseña',
        LOGIN: 'Iniciar sesión',
        REQUIRED_FIELD: 'campo requerido',
        OR: 'o con usuario',
        LOGIN_WITH_TRONLINK: 'Iniciar sesión con TronLink',
        TRONLINK_PROMPT:
            'Recomendado: conecta la billetera con la que te registraste.',
        TRONLINK_REFRESH_PROMPT:
            'Instala TronLink y actualiza la página para iniciar sesión con tu billetera.',
    },
    ru: {
        WELCOME_BACK: 'С возвращением',
        SUBTITLE: 'Войдите в свой аккаунт RealColibri.',
        ACCOUNT_LOGIN: 'ВОЙТИ В АККАУНТ',
        USERNAME_PLACEHOLDER: 'Имя пользователя',
        PASSWORD_PLACEHOLDER: 'Пароль',
        LOGIN: 'Войти',
        REQUIRED_FIELD: 'обязательное поле',
        OR: 'или по логину',
        LOGIN_WITH_TRONLINK: 'Войти через TronLink',
        TRONLINK_PROMPT:
            'Рекомендуется — подключите кошелёк, с которым регистрировались.',
        TRONLINK_REFRESH_PROMPT:
            'Установите TronLink и обновите страницу, чтобы войти через кошелёк.',
    },
    hy: {
        WELCOME_BACK: 'Բարի վերադարձ',
        SUBTITLE: 'Մուտք գործեք ձեր RealColibri հաշիվ:',
        ACCOUNT_LOGIN: 'ՄՈՒՏՔ ԳՈՐԾԵԼ ՀԱՇԻՎ',
        USERNAME_PLACEHOLDER: 'Օգտանուն',
        PASSWORD_PLACEHOLDER: 'Գաղտնաբառ',
        LOGIN: 'Մուտք գործել',
        REQUIRED_FIELD: 'պարտադիր դաշտ',
        OR: 'կամ օգտանունով',
        LOGIN_WITH_TRONLINK: 'Մուտք գործել TronLink-ով',
        TRONLINK_PROMPT:
            'Խորհուրդ է տրվում՝ միացրեք այն դրամապանակը, որով գրանցվել եք:',
        TRONLINK_REFRESH_PROMPT:
            'Տեղադրեք TronLink-ը և թարմացրեք էջը՝ ձեր դրամապանակով մուտք գործելու համար:',
    },
    fr: {
        WELCOME_BACK: 'Bon retour',
        SUBTITLE: 'Connectez-vous à votre compte RealColibri.',
        ACCOUNT_LOGIN: 'CONNEXION AU COMPTE',
        USERNAME_PLACEHOLDER: 'Nom d\'utilisateur',
        PASSWORD_PLACEHOLDER: 'Mot de passe',
        LOGIN: 'Connexion',
        REQUIRED_FIELD: 'champ requis',
        OR: 'ou avec l\'identifiant',
        LOGIN_WITH_TRONLINK: 'Connexion avec TronLink',
        TRONLINK_PROMPT:
            'Recommandé — connectez le portefeuille avec lequel vous vous êtes inscrit.',
        TRONLINK_REFRESH_PROMPT:
            'Installez TronLink et actualisez la page pour vous connecter avec votre portefeuille.',
    },
    de: {
        WELCOME_BACK: 'Willkommen zurück',
        SUBTITLE: 'Melden Sie sich bei Ihrem RealColibri-Konto an.',
        ACCOUNT_LOGIN: 'KONTO ANMELDUNG',
        USERNAME_PLACEHOLDER: 'Benutzername',
        PASSWORD_PLACEHOLDER: 'Passwort',
        LOGIN: 'Anmelden',
        REQUIRED_FIELD: 'Pflichtfeld',
        OR: 'oder mit Benutzername',
        LOGIN_WITH_TRONLINK: 'Mit TronLink anmelden',
        TRONLINK_PROMPT:
            'Empfohlen — verbinden Sie die Wallet, mit der Sie sich registriert haben.',
        TRONLINK_REFRESH_PROMPT:
            'Installieren Sie TronLink und aktualisieren Sie die Seite, um sich mit Ihrer Wallet anzumelden.',
    },
    it: {
        WELCOME_BACK: 'Bentornato',
        SUBTITLE: 'Accedi al tuo account RealColibri.',
        ACCOUNT_LOGIN: 'ACCESSO ACCOUNT',
        USERNAME_PLACEHOLDER: 'Nome utente',
        PASSWORD_PLACEHOLDER: 'Password',
        LOGIN: 'Accedi',
        REQUIRED_FIELD: 'Campo obbligatorio',
        OR: 'o con nome utente',
        LOGIN_WITH_TRONLINK: 'Accedi con TronLink',
        TRONLINK_PROMPT:
            'Consigliato — connetti il wallet con cui ti sei registrato.',
        TRONLINK_REFRESH_PROMPT:
            'Installa TronLink e aggiorna la pagina per accedere con il tuo wallet.',
    },
}

export default translations
